<template>
  <div class="row align-items-center top-bar">
    <div class="col-md-6">
      <h2 v-if="fetching && !hasTravelDates">
        {{ $t("listing.findingDeals") }}
      </h2>
      <h2 v-if="hasTravelDates && fetching">
        {{ $t("listing.findingPropertiesForDates") }}
      </h2>
      <h2 v-if="!fetching && totalElements && currentConfigKey('showListingCount') && hasTravelDates">
        {{ $t("listing.showingAvailableProperties") }}
      </h2>
      <div v-if="totalElements && currentConfigKey('showListingCount') && !hasTravelDates">
        <h2>
          {{ totalElements | numberFormat }} {{ $t("listing.dealsAvailable") }}
        </h2>
      </div>
      <div class="sort-container mr-2 mt-2">
        <b-dropdown
          right
          :class="['sort-dropdown', { 'sort-active': currentSort !== 'default' }]"
        >
          <template #button-content>
            <b-icon icon="arrow-down-up" class="mr-2 sort-icon"></b-icon>
            <span class="sort-text">{{ currentSortLabel }}</span>
          </template>
          <b-dropdown-item
            v-for="option in sortOptions"
            :key="option.value"
            @click="$emit('sort-change', option.value)"
            :active="currentSort === option.value"
          >
            {{ option.label }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="col-md-6 text-right">
      <p class="position-relative float-right">
        <img src="@/assets/images/map.png" alt="" />
        <a
          :tt="JSON.stringify(location)"
          :href="mapLink"
          target="_blank"
          class="show-on-map g-primary-button"
          >{{ $t("listing.showOnMap") }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { currentConfigKey } from "../../helpers/theme";
import { buildMapUrl } from "../../helpers/url";

export default {
  name: "ListingTopbar",
  props: {
    location: {
      type: Object,
      required: true,
    },
    destination: {
      type: String,
    },
    fetching: {
      type: Boolean,
    },
    totalElements: {
      type: Number,
    },
    currentSort: {
      type: String,
      default: "default",
    },
    hasTravelDates: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("config", ["currentListId"]),
    mapLink() {
      return buildMapUrl(this.location);
    },
    sortOptions() {
      const { latitude, longitude } = this.location;
      const options = [
        {
          value: "default",
          label: this.$t("listing.sortDefault"),
        },
        {
          value: "rating_desc",
          label: this.$t("listing.sortRatingDesc"),
        },
        {
          value: "rating_asc",
          label: this.$t("listing.sortRatingAsc"),
        },
        {
          value: "booking_type_asc",
          label: this.$t("listing.sortBookingTypeAsc"),
        },
        {
          value: "booking_type_desc",
          label: this.$t("listing.sortBookingTypeDesc")
        },
      ];

      if (latitude && longitude) {
        options.push({
          value: "distance_asc",
          label: this.$t("listing.sortDistanceAsc"),
        },
        {
          value: "distance_desc",
          label: this.$t("listing.sortDistanceDesc"),
        });
      }

      return options;
    },
    currentSortLabel() {
      const option = this.sortOptions.find(
        (opt) => opt.value === this.currentSort
      );
      return option ? option.label : this.$t("listing.sort.default") || "Sort";
    },
  },
  methods: {
    currentConfigKey,
  },
};
</script>
